export const getLocalsFromDashboardFiles = (files) => {
  if (!Array.isArray(files)) {
    return [];
  }

  const uniqueLocals = [];
  files.forEach((file) => {
    const parts = file.ada_file.split("/");
    const localId = parts[1];
    if (!uniqueLocals.includes(localId)) {
      uniqueLocals.push(localId);
    }
  });
  return uniqueLocals;
};

export function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
